export enum EarthingScheme {
    STANDARD = 'Standard (TN/TT)',
    ITNET = 'IT-net',
}

export enum EarthingSchemeLB {
    IT = 'IT',
    TN = 'TN',
}
